<template>
  <v-col cols="12">
    <div class="text-center">
      <vueSignature
        class="marginFirma marginFirma2"
        ref="signature"
        :sigOption="option"
        :w="'auto'"
        :h="'400px'"
      >
      </vueSignature>
    </div>
    <div cols="12 mt-2" class="text-right">
      <v-btn class="mt-3" @click="save">
        <v-icon>plus-thick</v-icon>
        Guardar
      </v-btn>
    </div>
  </v-col>
</template>

<script>
import vueSignature from "vue-signature";
import UserProfile from "../../data";

export default {
  name: "Firma",
  components: {
    vueSignature,
  },
data() {
    return {
      firmar: false,
      user: UserProfile.getUserData(),
      option: {
        penColor: "rgb(0,0,0)",
        backgroundColor: "rgb(255,255,255)",
      },
    }
},
  props: {
    rowPregunta: {
      type: Object,
      default: null
    },
  },
methods: {
    save() {
      // var _this = this;
      console.log(" this.$refs.signature.save.", this.$refs.signature.save);
      var png = this.$refs.signature.save();
      var jpeg = this.$refs.signature.save("image/jpeg");
      var svg = this.$refs.signature.save("image/svg+xml");
      console.log('png', png);
      console.log('jpeg', jpeg);
      console.log(svg);
      this.rowPregunta.respuestas[0].firma = jpeg;
        this.$emit('firma',this.rowPregunta)
    },

}
}
</script>

